import script from "./UnderConstruction.vue?vue&type=script&setup=true&lang=js"
export * from "./UnderConstruction.vue?vue&type=script&setup=true&lang=js"

import "./UnderConstruction.vue?vue&type=style&index=0&id=40c1021f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c1021f"]])

export default __exports__